import { render, staticRenderFns } from "./payDiaStep1.vue?vue&type=template&id=786532c6&scoped=true&"
import script from "./payDiaStep1.vue?vue&type=script&lang=js&"
export * from "./payDiaStep1.vue?vue&type=script&lang=js&"
import style0 from "./payDiaStep1.vue?vue&type=style&index=0&id=786532c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786532c6",
  null
  
)

export default component.exports